export default "__VITE_ASSET__BqhG_8jp__"